export const pvFinalBill = {
    PvFinalBillClass: {
        url: "Finanzierung/pvfinal",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_PvFinalBillClass_pvfinalbillReducer'
    }
};